export const LOCAL_WHITEBOARD_REFRESH_GUARD_MS = 5000;

/**
 * A local save can be echoed by the realtime broker before (or without) the
 * client identifier being available in the browser payload. Reloading the
 * canvas during this narrow window destroys Fabric's active selection.
 */
export const shouldSkipWhiteboardRefresh = ({eventClientId, currentClientId, ignoreUntil, now = Date.now()}) => (
    Boolean(eventClientId && eventClientId === currentClientId)
    || now < ignoreUntil
);
